import styled from "styled-components";

export const StyledAttachedFileContainer = styled.div({
    marginTop: "0",
});

export const StyledEmbeddedPdfInfo = styled.div({
    width: "100%",
    marginTop: "8px",
    padding: "16px 20px",
    border: "1px solid #dfe3e6",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});

export const StyledEmbeddedPdfInfoContent = styled.div({
    flex: 1,
});

export const StyledEmbeddedPdfFieldCount = styled.div({
    fontSize: "15px",
    fontWeight: 500,
    color: "#222",
    marginBottom: "6px",
});

export const StyledEmbeddedPdfDescription = styled.div({
    fontSize: "14px",
    fontWeight: 400,
    color: "#999",
});

export const StyledPreviewButton = styled.button({
    marginLeft: "24px",
    whiteSpace: "nowrap",
});